import React from "react";
import { Panel, Button, Alert } from "react-bootstrap";
import { connect } from "react-redux";
import { goBack } from "react-router-redux/actions";

export default connect(
  (state, ownProps) => ({}),
  (dispatch, ownProps) => ({
    back: () => dispatch(goBack()),
  }),
)(({ back }) => (
  <Panel id="page-not-found" bsStyle="danger">
    <Panel.Heading>
      <Panel.Title componentClass="h3">Page not found</Panel.Title>
    </Panel.Heading>
    <Panel.Body className="text-center">
      <h1>We apologise for the inconvenience!</h1>
      <br />
      <br />
      <Alert bsStyle="warning">
        Somehow you reached a page which does not exist or where you don't have
        access.
      </Alert>
      <br />
      <br />
      <Button id="back" bsStyle="primary" onClick={back}>
        Go Back
      </Button>
    </Panel.Body>
  </Panel>
));



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/PageNotFound.js